import React, { useState, useCallback } from 'react'
import { Link } from 'react-router-dom'
import { Auth } from 'aws-amplify'

import SocialLoginButtons from '../components/SocialLoginButtons'

import backgroundImage from '../images/header-17.jpg'
import useTitle from '../hooks/useTitle'

interface SignupFormElements extends HTMLFormControlsCollection {
  email: HTMLInputElement
  password: HTMLInputElement
}

const Signup: React.FC = () => {
  useTitle("Create Account | Speech2")

  const [ errorMessage, setErrorMessage ] = useState<string>()
  const [ successMessage, setSuccessMessage ] = useState<string>()

  const signup = useCallback(
    async (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault()

      const elements = event.currentTarget.elements as SignupFormElements
      const email = elements.email.value
      const password = elements.password.value

      const attrs = {
        username: email,
        password,
        attributes: {
          email
        }
      }

      try {
        await Auth.signUp(attrs)
        setSuccessMessage(
          "A confirmation link has been sent to your e-mail. Click it, then come back and sign in."
        )
      } catch(err) {
        setErrorMessage(
          "We were not able to sign you up right now. Please try again."
        )
        console.error(err)
      }
    },
    [  ]
  )

  const signupScreen = (
    <div className="card-body">
      <h1 className="h2 text-center">Create Account</h1>
      {errorMessage && <div className="alert alert-danger" role="alert">{errorMessage}</div>}
      {successMessage && <div className="alert alert-success" role="alert">{successMessage}</div>}

      <SocialLoginButtons />

      <form onSubmit={signup}>
        <div className="form-group">
          <label htmlFor="email">Email:</label>
          <input
            tabIndex={1}
            id="email"
            name="email"
            type="email"
            className="form-control"
            placeholder="Enter your email address"
            required={true}
          />
        </div>

        <div className="form-group">
          <div className="d-flex justify-content-between">
            <label htmlFor="password">Password:</label>
          </div>
          <input
            tabIndex={2}
            id="password"
            name="password"
            type="password"
            className="form-control"
            placeholder="Choose a password"
            required={true}
          />
          <small>* Password must be at least 8 characters.</small>
        </div>

        <div className="form-group">
          <div className="custom-control custom-checkbox">
            <input
              tabIndex={3}
              type="checkbox"
              className="custom-control-input"
              required={true}
              id="tosCheck"
            />

            <label className="custom-control-label" htmlFor="tosCheck">
              I agree to the <a href="https://speech2.io/privacy.html" target="_blank" rel="noreferrer noopener">Privacy Policy</a>
            </label>
          </div>
        </div>

        <div className="form-group">
          <button
            tabIndex={4}
            className="btn btn-block btn-lg btn-primary"
            type="submit"
          >
            Sign up
          </button>
        </div>
      </form>

      <div className="text-center text-small mt-3">
        <span>Already have an account? <Link to="/login">Log in here</Link></span>
      </div>
    </div>
  )

  return (
    <section className="height-100 bg-gradient-3">
      <img src={backgroundImage} alt="background" className="bg-image opacity-10" />
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-5 col-md-7">
            <div className="card py-3 shadow-lg">
              { signupScreen }
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Signup
